module.exports = "<div class=\"modal-archismall\">\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\">Attenzione</h3>\n    </div>\n    <div class=\"modal-body\">\n        <i class='fa fa-exclamation-triangle'></i>\n        <span> Gentile cliente, stai per disdire il servizio ArchiSMALL in uso, vuoi proseguire con la scelta?</span>\n    </div>\n    <div class=\"modal-footer\">\n        <a ng-click=\"cancel()\">Annulla</a>\n        <a ng-click=\"ok()\">Ok</a>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/sections/usersettings/unsubscribe-modal/unsubscribe-modal.html
// module id = 1321
// module chunks = 0